module.exports = __webpack_public_path__ + "static/duke_univ-b7c00fbc360309c10d2f460eaef907ce.png";